import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function InsuranceIcon({ className }: IconProps) {
  return (
    <svg
      width="73"
      height="91"
      viewBox="0 0 73 91"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1753)">
        <path
          d="M36.5 0L0 12.7427V57.0285C0 77.3568 36.5 91 36.5 91C36.5 91 73 77.3841 73 57.0285V12.7427L36.5 0Z"
          fill="#FAFBFD"
        />
        <path
          d="M54.75 43.6854C54.75 53.7267 46.569 61.8854 36.5 61.8854C26.431 61.8854 18.25 53.7267 18.25 43.6854C18.25 33.644 26.431 25.4854 36.5 25.4854C46.569 25.4854 54.75 33.644 54.75 43.6854Z"
          fill="#00C4B3"
        />
        <path
          d="M38.2515 54.491C37.5128 54.491 36.7466 54.2181 36.172 53.6724L26.1852 44.3132C24.9539 43.1671 24.8992 41.2298 26.0484 40.0292C27.1975 38.8013 29.1128 38.7467 30.3441 39.8928L38.1694 47.2328L65.9685 19.5099C67.1451 18.3366 69.0877 18.3366 70.2643 19.5099C71.4408 20.6832 71.4408 22.6205 70.2643 23.7938L40.3857 53.5905C39.7837 54.1908 39.0176 54.491 38.2241 54.491"
          fill="#FAFBFD"
        />
        <path
          d="M36.5 0L0 12.7427V57.0285C0 77.3568 36.5 91 36.5 91C36.5 91 73 77.3841 73 57.0285V12.7427L36.5 0ZM63.2594 57.0285C63.2594 61.7217 58.307 67.6702 49.6608 73.3457C44.7358 76.5928 39.7013 79.0486 36.4726 80.4675C33.2714 79.0486 28.2369 76.5928 23.2845 73.3457C14.6383 67.6702 9.68591 61.7217 9.68591 57.0285V19.6189L36.4453 10.287L63.2046 19.6189V57.0285H63.2594Z"
          fill="#EAEDF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1753">
          <rect width="73" height="91" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
